import { useEffect } from 'react'
import { initMetaPixel, trackEvent, PRODUCT } from '../utils/metaPixel'

/**
 * Boots the Meta Pixel and fires the landing page's entry events:
 * PageView (visit) and ViewContent (product page viewed).
 */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
    trackEvent('PageView')
    trackEvent('ViewContent', PRODUCT)
  }, [])
}
